export default {
  full_name: 'Name',
  tagline: 'Tagline',
  phone_number: 'Phone Number',
  email: 'Email',
  personal_link: 'Personal Link',
  address: 'City, State',
  objective: 'Objective',
  summary: 'Summary',

  work_experience_organization_name: 'Organization Name',
  work_experience_organization_address: 'Organization City, State',
  work_experience_from: 'From',
  work_experience_to: 'To',
  work_experience_job_title: 'Role Title',
  work_experience_role_details: 'Role Title',
  work_experience_role_description: `Role Description`,
  work_experience_role_achievements: `Role Achievements`,
  work_experience_date: `Date`,

  education_organization_name: 'Institution Name',
  education_organization_address: 'Institution City, State',
  education_from: 'From',
  education_to: 'To',
  education_role_details: 'Degree',
  education_degree_title: 'Degree',
  education_field_title: 'Field of Study',
  education_role_description: `Description`,
  education_date: `Date`,

  skill_title: 'Skill',
  skill_organization_name: 'Skill Type',
  awards_and_honors_organization_name: 'Organization Name',
  awards_and_honors_organization_address: 'Organization City, State',
  awards_and_honors_role_details: 'Award Title',
  awards_and_honors_award_title: 'Award Title',
  awards_and_honors_issue_date: 'Issued Date',
  awards_and_honors_award_description: `Description`,

  volunteer_work_organization_name: 'Organization Name',
  volunteer_work_organization_address: 'Organization City, State',
  volunteer_work_from: 'From',
  volunteer_work_to: 'To',
  volunteer_work_role_title: 'Role Title',
  volunteer_work_cause_title: 'Cause Title',
  volunteer_work_role_details: 'Role Title',
  volunteer_work_role_description: `Description`,
  volunteer_work_date: `Date`,

  certifications_organization_name: 'Organization Name',
  certifications_organization_address: 'Organization City, State',
  certifications_from: 'From',
  certifications_to: 'To',
  certifications_certification_title: 'Certification Title',
  certifications_role_details: 'Certification Title',
  certifications_certification_description: `Certificate details`,
  certifications_date: `Date`,

  projects_organization_name: 'Organization Name',
  projects_organization_address: 'Organization City, State',
  projects_from: 'From',
  projects_to: 'To',
  projects_project_title: 'Project Title',
  projects_url_title: 'Associated URL',
  projects_role_details: 'Project Title',
  projects_project_description: `Description`,
  projects_project_date: `Date`,

  research_experience_organization_name: 'Organization Name',
  research_experience_organization_address: 'Organization City, State',
  research_experience_from: 'From',
  research_experience_to: 'To',
  research_experience_research_title: 'Research Title',
  research_experience_url_title: 'Associated URL',
  research_experience_role_details: 'Research Title',
  research_experience_research_description: `Description`,
  research_experience_research_date: `Date`,

  leadership_organization_name: 'Organization Name',
  leadership_organization_address: 'Organization City, State',
  leadership_from: 'From',
  leadership_to: 'To',
  leadership_role_title: 'Role Title',
  leadership_url_title: 'Associated URL',
  leadership_role_details: 'Role Title',
  leadership_role_description: `Description`,
  leadership_date: `Date`,

  associations_organization_name: 'Organization Name',
  associations_organization_address: 'Organization City, State',
  associations_from: 'From',
  associations_to: 'To',
  associations_association_title: 'Title',
  associations_url_title: 'Associated URL',
  associations_role_details: 'Title',
  associations_association_description: `Description`,
  associations_date: `Date`,

  extra_curricular_organization_name: 'Organization Name',
  extra_curricular_organization_address: 'Organization City, State',
  extra_curricular_from: 'From',
  extra_curricular_to: 'To',
  extra_curricular_activity_title: 'Activity Title',
  extra_curricular_url_title: 'Associated URL',
  extra_curricular_role_details: 'Activity Title',
  extra_curricular_activity_description: `Description`,
  extra_curricular_date: 'Date',

  language: 'Language',

  hobbies_and_interests: 'Photography, sports, reading etc.',

  publication: 'Type your publication here',
  publication_tetra: 'Publication',

  courses_organization_name: 'Organization Name',
  courses_organization_address: 'Organization City, State',
  courses_role_details: 'Course Title',
  courses_course_title: 'Course Title',
  courses_completion_date: 'Completion Date',
  courses_course_description: `Description`,

  conferences_organization_name: 'Organization Name',
  conferences_organization_address: 'Organization City, State',
  conferences_role_details: 'Conference/Presentation Title',
  conferences_conference_title: 'Conference/Presentation Title',
  conferences_date: 'Date',
  conferences_conference_description: `Description`,

  references_organization_name: 'Organization Name',
  references_organization_address: 'Organization City, State',
  references_reference_title: 'Title',
  references_reference_name_title: 'Name',
  references_reference_email_title: 'Email',
  references_role_details: 'Name',

  patents_organization_name: 'Organization Name',
  patents_organization_address: 'Organization City, State',
  patents_patent_title: 'Patent Title',
  patents_patent_id_title: 'Patent ID',
  patents_patent_status_title: 'Patent Status',
  patents_patent_country_title: 'Issue Country',
  patents_patent_date: 'Issue Date',
  patents_patent_url_title: 'Patent URL',
  patents_role_details: 'Patent Title',
  patents_patent_description: `Description`,

  test_scores_organization_name: 'Organization Name',
  test_scores_organization_address: 'Organization City, State',
  test_scores_test_title: 'Test Name',
  test_scores_role_details: 'Test Name',
  test_scores_date: 'Test Date',
  test_scores_test_description: `Description`,

  sender_name: 'Name',
  sender_tagline: 'Tagline',
  sender_phone_number: 'Phone Number',
  sender_address: 'City, State',
  sender_email: 'Email',
  receiver_name: 'Name',
  receiver_tagline: 'Tagline',
  receiver_organization: 'Organization name',
  receiver_address: 'City, State',
  letter_date: 'Date',
  letter_body: 'Start writing your letter here',
  open_greeting: 'Dear/Madam/Sir',
  subject_line: 'Subject',
  close_greeting: 'Regards/Kindly',
  coverLetter_personalInfo_tetra: 'Personal Info',
  coverLetter_receiverInfo_tetra: 'Receiver Info',
  coverLetter_openGreeting_tetra: 'Greeting',
  coverLetter_letterBody_tetra: 'Letter Body',
};
